var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[(_vm.title)?_c('div',[_c('v-card-title',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.title))])],1):_vm._e(),_c('v-card-text',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }